module.exports = __webpack_public_path__ + "img/control_de_calidad_4-3_1024.ff73799a.jpg";